// import { ItemConfiguracao } from './catalogo';
/* *********************************************** */
/* ********************* FTA ********************* */

/* *********************************************** */
export class FTA {
    fta: number;
    versao: number;
    // vrsFta:string;

    formatoIed: string;
    mciContratoIed: string;
    codProdutoIed: string;
    prioridadeExecucao: string;
    alias: string;
    orientacaoDoFluxo: string;
    codFormatoIed: string;
    contratoled: string;
    nome: string;
    msgHistoricoInclusaoFta: string;
    descricao: string;
    codTipoEstado: number;
    subfluxoVigente: number;
    subfluxoPossiveis: Array<SubfluxoPossivel> = new Array<SubfluxoPossivel>();
    eventos: Array<Evento>;
    historico: Array<Historico>;
    codModelo: number;
    contratoIed: number;
    validade: string;
    indicadorStepRoteiroPendenteDemandante: boolean;
    indicadorStepRoteiroPendenteSuporte: boolean;
    permissaoUsoEvento: Array<Permissoes>;
    parametrosUsoEvento: Array<Parametros>;


    buscarEventoPorCodigo(codigo: number): Evento {
        let evento: Evento = null;
        this.eventos.forEach((item, index) => {
            if ((item as Evento).evento == codigo) {
                evento = Object.assign({}, this.eventos[index]);
            }
        });
        return evento;
    }

    salvarEvento(evento: Evento) {
        var i = -1;
        this.eventos.forEach((item, index) => {
            if ((item as Evento).evento == evento.evento) {
                i = index;
            }
        });
        if (i == -1) {
            this.eventos.push(evento);
        } else {
            Object.assign(this.eventos[i], evento);
        }
    }

    excluirEvento(evento: Evento) {
        let novoEventos = [];
        this.eventos.forEach(evt => {
            let ev = evt as Evento;
            if (ev.evento != evento.evento) {
                novoEventos.push(ev);
            }
        });
        this.eventos = novoEventos;
    }
}

export class ResumoFTA {
    // Origem
    'tipoOrigem': string;
    'arqOrigem': string;
    'ambienteMFOrigem': string;
    'hostnameOrigem': string;
    'uorOrigem': string;
    'tpArqOrigem': string;
    'aposTransf': string;
    'moverPara': string;
    // Operações
    'descriptografar': string;
    'descompactar': string;
    'layout': string;
    'compactar': string;
    'inserirHeader': string;
    'inserirTrailer': string;
    'criptografar': string;
    // Destino
    'tipoDestino': string;
    'arqDestino': string;
    'ambienteMFDestino': string;
    'hostnameDestino': string;
    'uorDestino': string;
    'arqExistente': string;
    'recfm': string;
    'lrecl': string;
    'blksize': string;
    'rotinaDestino': string;
    // Retorno
    'ambienteMFRetorno': string;
    'arqOrigemRetorno': string;
    'arqDestinoRetorno': string;
    'descriptografarR': string;
    'descompactarR': string;
    'layoutR': string;
    'compactarR': string;
    'inserirHeaderR': string;
    'inserirTrailerR': string;
    'criptografarR': string;
}

export class SubfluxoPossivel {
    nrSubfluxo: any | Number;
    descricaoSubfluxo: string;
    vigente: string;

    // constructor(nrSubfluxo: number, descricaoSubfluxo: string) {
    //     this.nrSubfluxo = nrSubfluxo;
    //     this.descricaoSubfluxo = descricaoSubfluxo;
    // }
}

export class Permissoes {
    codUserAplicacao: Number;
    versaoUserAplicacao: Number;
    nomeUserAplicacao: String;
    codMci: String;
    codUor: String;
    chaveAcesso: String;
}

export class Evento {
    evento: number;
    etapa: number;
    grupo: any | Array<Number> = new Array<Number>();
    descricao: string;
    codTipoEvento: any | Number;
    codTipoTrigger: number;
    codTipoPeriodicidade: number;
    indMonitorarPeriodicidade: boolean;
    nomeTipoPeriodicidade: string;
    subfluxoVinculado: Array<Number> = new Array<Number>();
    formaConstrucaoChave: string;
    mensagemParaProtocoloEmSucesso: string;
    mensagemParaProtocoloEmErro: string;
    qtdSegundosMaxEntreEventos: Number;
    servicosVinculados: Array<ServicoVinculado>;
    dependencia: Array<Dependencia>;
    janelaPermissaoOcorrencia: Array<JanelaPermissaoOcorrencia>;
    scheduleExecucao: Array<ScheduleExecucao>;
    detalheEventoTransmissao: EventoTransmissao;
    parametrosSelecionados: any;
    parametrosSelecionadosOperacao: any;
    listaParametrosSelecionados: any;
    listaParametrosSelecionadosOperacao: any;
    detalheEventoPermissoes: EventoPermissoes;
    detalheEventoOperacao: EventoOperacao;
    detalheEventoProcessamento: EventoProcessamento;
    permissaoUsoEvento: Array<any> = [];
    parametrosEntradaEvento: Array<ParametrosEntradaEvento> = new Array<ParametrosEntradaEvento>();
    cliente: Cliente;
}

export class ServicoVinculado {
    codigo: number;
    versao: number;
    nome: string;
    codTipoEstado: number; // adicionado para tratar erro

}

export class Dependencia {
    eventoAnterior: Number;
    codRetornoMin: Number;
    codRetornoMax: Number;

}

export class JanelaPermissaoOcorrencia {
    diaSemana: Number;
    diaMes: number;
    ano: number;
    codTipoDiaUtil: Number;
    horaInicio: string;
    horaFim: string;
}

export class ScheduleExecucao {
    diaDaSemana: string;
    diaDoMes: string;
    ano: string;
    codTipoDiaUtil: string;
    horaExecucaoInicial: string;
    horaExecucaoFinal: string;
    segundo: string;
    minuto: string;
    mes: string;
    hora: string;
}


export class Parametro {
    conteudoPadrao?: any;
    parmNome?: string;
    nomeSubtipoDado?: string;
    nomeTipoDado?: string;
    parmConteudo?: Array<ParametroConteudo> = new Array<ParametroConteudo>();
    parametrosEntradaEvento?: Array<ParametrosEntradaEvento> = new Array<ParametrosEntradaEvento>();
    obrigatorio?: boolean;
    selecionado?: boolean;
    descricao?: string;
}

export class ParametroConteudo {
    nrPosicao: number;
    conteudo: string;
    selecionado: boolean;
}

export class ParametrosEntradaEvento {
    nomeParametroEntrada: string;
    descricaoParametroEntrada: string;
    nomeTipoDado: string;
    nomeSubtipoDado: string;
    obrigatorio: boolean;
}

export class Parametros {
    nomeParametroEntrada: string;
    // nomeSubtipoDado: Array<string>; // TODO: comentado devido diferença no swagger
    descricaoParametroEntrada: string;
    nomeTipoDado: string;
    nomeSubtipoDado: string;
    obrigatorio: boolean;
}

export class ParametrosConteudo {
    nome: string;
}

export class OrigemTransmissao {
    clienteOrigem: Cliente = new Cliente();
    codInstalacaoProdutoOrigem: number;
    vrsInstalacaoProdutoOrigem: number;
    nomeInstalacaoProdutoOrigem: string;
    parmInstalacaoProdutoOrigem: Array<ParametroInstalacaoProduto> = new Array<ParametroInstalacaoProduto>();
}

export class OrigemPermissoes {
    clienteOrigem: Cliente = new Cliente();
    codInstalacaoProdutoOrigem: number;
    vrsInstalacaoProdutoOrigem: number;
    nomeInstalacaoProdutoOrigem: string;
    parmInstalacaoProdutoOrigem: Array<ParametroInstalacaoProduto> = new Array<ParametroInstalacaoProduto>();
}

export class OrigemParametros {
    clienteOrigem: Cliente = new Cliente();
    codInstalacaoProdutoOrigem: number;
    vrsInstalacaoProdutoOrigem: number;
    nomeInstalacaoProdutoOrigem: string;
    parmInstalacaoProdutoOrigem: Array<ParametroInstalacaoProduto> = new Array<ParametroInstalacaoProduto>();
}

export class OrigemTransmissaoMigracao {
    clienteOrigem: Cliente = new Cliente();
    codInstalacaoProdutoOrigem: number;
    vrsInstalacaoProdutoOrigem: number;
    nomeInstalacaoProdutoOrigem: string;
    parmInstalacaoProdutoOrigem: Array<ParametroInstalacaoProduto> = new Array<ParametroInstalacaoProduto>();
    numeroEvento: number;
}

export class DestinoTransmissao {
    clienteDestino: Cliente = new Cliente();
    codInstalacaoProdutoDestino: number;
    vrsInstalacaoProdutoDestino: number;
    nomeInstalacaoProdutoDestino: string;
    parmInstalacaoProdutoDestino: Array<ParametroInstalacaoProduto> = new Array<ParametroInstalacaoProduto>();
}


export class DestinoPermissoes {
    clienteDestino: Cliente = new Cliente();
    codInstalacaoProdutoDestino: number;
    vrsInstalacaoProdutoDestino: number;
    nomeInstalacaoProdutoDestino: string;
    parmInstalacaoProdutoDestino: Array<ParametroInstalacaoProduto> = new Array<ParametroInstalacaoProduto>();
}

export class DestinoParametros {
    clienteDestino: Cliente = new Cliente();
    codInstalacaoProdutoDestino: number;
    vrsInstalacaoProdutoDestino: number;
    nomeInstalacaoProdutoDestino: string;
    parmInstalacaoProdutoDestino: Array<ParametroInstalacaoProduto> = new Array<ParametroInstalacaoProduto>();
}


export class DestinoTransmissaoMigracao {
    clienteDestino: Cliente = new Cliente();
    codInstalacaoProdutoDestino: number;
    vrsInstalacaoProdutoDestino: number;
    nomeInstalacaoProdutoDestino: string;
    parmInstalacaoProdutoDestino: Array<ParametroInstalacaoProduto> = new Array<ParametroInstalacaoProduto>();
    numeroEvento: number;
}

export class EventoTransmissao {
    nomeItemConfiguracaoProduto?: string;
    origem?: Array<OrigemTransmissao> = new Array<OrigemTransmissao>();
    destino?: Array<DestinoTransmissao> = new Array<DestinoTransmissao>();
    codLayout?: number;
    vrsLayout?: number;
    nomeLayout?: string;
    qtdMinimaByte?: number;
    qtdMaximaByte?: number;
    layoutArquivo?: number;
    parmTransmissao?: Array<Parametro> = new Array<Parametro>();
}

export class EventoPermissoes {
    nomeItemConfiguracaoProduto: string;
    origem: Array<OrigemPermissoes> = new Array<OrigemPermissoes>();
    destino: Array<DestinoPermissoes> = new Array<DestinoPermissoes>();
    codLayout: number;
    vrsLayout: number;
    nomeLayout: string;
    qtdMinimaByte: number;
    qtdMaximaByte: number;
    layoutArquivo: number;
    cliente: Cliente;
    autorizacaoExtraUsersSelecionados: any;
    permissaoUsoEvento: Array<any> = [];
    parmPermissoes: Array<Parametro> = new Array<Parametro>();
}

export class EventoParametros {
    nomeItemConfiguracaoProduto: string;
    codLayout: number;
    vrsLayout: number;
    parametros: Parametro;
    nomeLayout: string;
    qtdMinimaByte: number;
    qtdMaximaByte: number;
    layoutArquivo: number;
    cliente: Cliente;
    origem: Array<OrigemParametros> = new Array<OrigemParametros>();
    destino: Array<DestinoParametros> = new Array<DestinoParametros>();
    autorizacaoExtraUsersSelecionados: any;
    permissaoUsoEvento: Array<any> = [];
    parmParametros: Array<Parametro> = new Array<Parametro>();
}

export class EventoOperacao {
    codOperacao?: number;
    vrsOperacao?: number;
    nomeOperacao?: string;
    codLayout?: number;
    vrsLayout?: number;
    nomeLayout?: string;
    parmOperacao?: Array<Parametro> = new Array<Parametro>();
    layoutArquivo?: number;
}

export class EventoProcessamento {
    clienteResponsavelProcessamento: Cliente;
    mascaraNomeArquivoProcessado: string;
    siglaSistemaMainframeResponsavelProcessamento: string;
    programaMainframeResponsavelProcessamento: string;
    programaBaixaPlataformaResponsavelProcessamento: string;
}

export const enum TipoDeEvento {
    TRANSMISSAO = 1,
    OPERACAO = 2,
    PROCESSAMENTO = 3
}

/* **************************************************** */
/* ********************* Operação ********************* */

/* **************************************************** */
export class Operacao {
    codigo: number;
    versao: number;
    nome: string;
    descricao: string;
    codTipoEstado: number;
    nomeTipoEstado: string;
    parmEntrada: Array<ParametroEntradaOperacao>;
    parmSaida: Array<ParametroSaidaOperacao>;
    returnCode: Array<ReturnCode>;
    historico: Array<Historico>;
}

export class ParametroEntradaOperacao {
    codigo?: number;
    nome: string;
    descricao: string;
    nomeTipoDado: string;
    nomeSubtipoDado: string;
    obrigatorio: boolean;
    conteudoPadrao: Array<string>;
}

export class ParametroSaidaOperacao {
    nome: string;
    descricao: string;
    nomeTipoDado: string;
    nomeSubtipoDado: string;
}

export class ReturnCode {
    'rc': number;
    'descricao': string;
}

/* ************************************************** */
/* ********************* Layout ********************* */

/* ************************************************** */
export class Layout {
    'codigo': number;
    'versao': number;
    'nome': string;
    'descricao': string;
    'codTipoEstado': number;
    'nomeTipoEstado': string;
    'historico': Array<Historico>;
    'header': Array<HeaderLayout>;
    'qtdMaxPosicoesPorRegistro': number;
}

export class HeaderLayout {
    'posicaoInicial': number;
    'posicaoFinal': number;
    'conteudo': string;
}

/* *************************************************** */
/* ********************* Serviço ********************* */

/* *************************************************** */
export class Servico {
    codigo: number;
    versao: number;
    nome: string;
    descricao: string;
    codTipoEstado: number;
    historico: Array<Historico>;
}

export class Historico {
    'dataHora': string;
    'codTipoEstado': number;
    'nomeTipoEstado': string;
    'matricula': string;
    'observacao': string;
}

/* *************************************************** */
/* ********************* Cliente ********************* */

/* *************************************************** */
export class Cliente {
    codTipoCliente: number;
    userAplicacao: UserAplicacao = new UserAplicacao();
    mci: MCI = new MCI();
    uor: UOR = new UOR();
}

export class UserAplicacao {
    codUserAplicacao?: number;
    versaoUserAplicacao?: number;
    nomeUserAplicacao?: string;
    nomeCertificadoVinculado?: string;
    mciVinculado?: string;
    uorVinculada?: string;
    codMci?: string;
    codUor?: string;
    chaveAcesso?: string;
    descricaoUserAplicacao?: string;
    codTipoEstado?: number;
    historico?: Array<Historico>;
}

export class MCI {
    codMci: number;
    nomeCliente: string;
}

export class UOR {
    codUor: number;
    nomeDependencia: string;
}

/* ************************************************************* */
/* ********************* Item Configuração ********************* */

/* ************************************************************* */
export class ItemConfiguracao {
    nome: string;
    tipoItemConfiguracao: number;
    itemConfiguracaoProduto: ItemConfiguracaoProduto = new ItemConfiguracaoProduto();
    itemConfiguracaoServidor: ItemConfiguracaoServidor = new ItemConfiguracaoServidor();
    itemConfiguracaoDemais: ItemConfiguracaoDemais = new ItemConfiguracaoDemais();
}

export class ItemConfiguracaoProduto {
    categoria: string;
    subcategoria: string;
    tipo: string;
    parmEntradaInstalacaoProduto: Array<ParametroEntradaInstalacaoProduto> = new Array<ParametroEntradaInstalacaoProduto>();
    parmEntradaTransmissaoComProduto: Array<ParametroEntradaInstalacaoProduto> = new Array<ParametroEntradaInstalacaoProduto>();
    parmEntradaPermissoesComProduto: Array<ParametroEntradaInstalacaoProduto> = new Array<ParametroEntradaInstalacaoProduto>();
}

export class ItemParametroInstalacaoAgrupado {
    label: string;
    valor: string;
}

export class ParametroEntradaInstalacaoAgrupado {
    label: string;
    value: string;
    items: Array<ItemParametroInstalacaoAgrupado>;
}

export class ParametroEntradaInstalacaoProduto {
    nome: string;
    descricao: string;
    nomeTipoDado: string;
    nomeSubtipoDado: string;
    obrigatorio: boolean;
    conteudoPadrao: Array<String> = new Array<String>();
    novoParametro: boolean;
    nomeItemConfiguracaoPai: string;
}

export class ParametroEntradaTransmissaoComProduto {
    nome: string;
    descricao: string;
    nomeTipoDado: string;
    nomeSubtipoDado: string;
    obrigatorio: boolean;
    conteudoPadrao: Array<String> = new Array<String>();
    novoParametro: boolean;
    nomeItemConfiguracaoPai: string;
}

export class ItemConfiguracaoServidor {
    'categoria': string;
    'subcategoria': string;
    'tipo': string;
    'ambiente': string;
    'plataforma': string;
    'sistemaOperacional': string;
    'versaoSistemaOperacional': string;
    'enderecoIp': string;
}

export class ItemConfiguracaoDemais {
    'categoria': string;
    'subcategoria': string;
    'tipo': string;
}

export class ItemParamConfiguracao {
    'nome': string;
    'descricao': string;
    'nomeTipoDado': string;
    'nomeSubtipoDado': string;
    'obrigatorio': boolean;
    'conteudoPadrao': Array<string>;
    'parmConteudo': Array<ParametroConteudo>;
}

export class ObjetoPainel {
    etapa;
    botoesList = Array<BntProps>();
}

export class BntProps {
    label: string;
    index: number = 0;
    indexArray: number = 0;
    indexTela: number = 0;
    botao: any;
}

export class EventoPrincipal {
    etapas = Array<Etapa>();
}

export class Etapa {
    id: number;
    titulo: string;
    botoesList = Array<BntProps>();
    eventos = Array<Evento>();
    indexEvento: number;
}

export class ArrayDashboard {
    'tipo': String;
    'codigo': number;
    'versao': number;
    'nome': string;
}


/* ***************************************************************** */
/* ********************* Instalação de produto ********************* */

/* ***************************************************************** */
export class InstalacaoProduto {
    codigo: number;
    versao: number;
    nomeItemConfiguracaoProduto: string;
    nomeInstalacao: string;
    descricaoInstalacao: string;
    codTipoEstado: number;
    parmInstalacaoProduto: Array<ParametroInstalacaoProduto>;
    itemConfiguracaoVinculado: Array<string>;
    clienteVinculado: Array<Cliente>;
    historico: Array<Historico>;
}

export class ParametroInstalacaoProduto {
    parmNome: string;
    parmConteudo: Array<ParametroConteudoInstalacaoProduto>;
}

export class ParametroConteudoInstalacaoProduto {
    nrPosicao: number;
    conteudo: string;
}




// WEBPACK FOOTER //
// ./src/model/catalogo.ts